import { render } from "./MeuQueridometro.vue?vue&type=template&id=a0233848&scoped=true"
import script from "./MeuQueridometro.vue?vue&type=script&lang=js"
export * from "./MeuQueridometro.vue?vue&type=script&lang=js"

import "./MeuQueridometro.vue?vue&type=style&index=0&id=a0233848&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/AeAAppDev/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0233848"]])

export default __exports__